import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalProps, Textarea } from '@heroui/react'
import { getOrderShortId } from '#entities/order'
import { useFormFieldStyleProps } from '#shared/lib/ui'
import { v } from '#shared/lib/validation'
import useOrderFeedbackForm from '../lib/use-order-feedback-form'
import OrderFeedbackFormValue from '../model/order-feedback-form-value'
import useOrderFeedBackMutation from '../state/use-order-feedback-mutation'
import RatingInput from './rating-input'

interface OrderFeedbackModalProps extends Omit<ModalProps, 'children'> {
  orderId: string
}

export default function OrderFeedbackModal({ orderId, onClose, ...props }: OrderFeedbackModalProps) {
  const formFieldStyleProps = useFormFieldStyleProps()

  const shortId = getOrderShortId(orderId)

  const orderFeedbackMutation = useOrderFeedBackMutation()

  const form = useOrderFeedbackForm({
    onSubmit: async value => {
      try {
        await orderFeedbackMutation.mutateAsync({
          orderId,
          rating: value.rating,
          comment: value.comment || null,
        })
      } catch {
        // Who does give a fuck about feedback submitting error?
      }
      onClose?.()
    },
  })

  return (
    <Modal onClose={onClose} {...props}>
      <ModalContent>
        {onClose => (
          <>
            <ModalHeader>Отзыв о заказе {shortId}</ModalHeader>

            <ModalBody>
              <form.Field
                name="rating"
                validators={v<OrderFeedbackFormValue, 'rating'>(
                  value => value === null && 'Необходимо указать рейтинг'
                )}
              >
                {field => <RatingInput value={field.state.value} onValueChange={field.handleChange} />}
              </form.Field>

              <form.Field name="comment">
                {field => (
                  <Textarea
                    {...formFieldStyleProps}
                    placeholder="Комментарий"
                    value={field.state.value}
                    onValueChange={field.handleChange}
                  />
                )}
              </form.Field>
            </ModalBody>

            <ModalFooter>
              <Button onClick={onClose}>Закрыть</Button>

              <form.Subscribe selector={state => [state.canSubmit, state.isSubmitting]}>
                {([canSubmit, isSubmitting]) => (
                  <Button color="primary" onClick={form.handleSubmit} isLoading={isSubmitting} isDisabled={!canSubmit}>
                    Отправить
                  </Button>
                )}
              </form.Subscribe>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  )
}
